<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st3"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('bulletin_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('bulletin_add_button')"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('bulletin_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="title"
          title="公告标题"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.title"
            placeholder="请输入公告标题"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="editName"
          title="编辑人"
          width="120"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.editName"
            placeholder="请输入编辑人"
            clearable
          />
        </template>
      </vxe-table-column>
        
      <vxe-table-column>
        <vxe-table-column
          field="ifRelease"
          title="是否发布"
          width="120"
          sortable
        >
          <template v-slot="{row}">
            {{ dicts.isRelease[row.ifRelease] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.ifRelease"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(v,k) in dicts.isRelease"
              :key="k"
              :label="v"
              :value="k"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
          
        title="操作"
        fixed="right"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('bulletin_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('bulletin_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code)"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('bulletin_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDelete(scope.row.code)"
            >
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('bulletin_publish_button')&&scope.row.ifRelease==='0'"
            class="item"
            effect="dark"
            content="发布"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcPublish(scope.row.code)"
            >
              <i class="el-icon-check" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
  
    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="1000"
      height="920"
      resize
    >
      <compAdd
        :key="timer"
        ref="addRef"
        :dicts="dicts"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="1000"
      height="920"
      resize
    >
      <compEdit
        :key="timer"
        ref="editRef"
        :dicts="dicts"
        :edit-code="editCode"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="1000"
      height="840"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
  <script>
  import compAdd from "./components/bulletinAdd.vue";
  import compEdit from "./components/bulletinEdit.vue";
  import compDetail from "./components/bulletinDetail.vue";
  import request from "@/utils/request";
  import { getDictByType } from "@/api/commonApi";
  export default {
    name: "BulletinList",
    components: {
      compAdd,
      compEdit,
      compDetail
    },
    data() {
      return {
        timer: '',
        editCode:'',
        message: "",
        loading: false,
        tableData: [],
        modelAddFlag: false,
        modelEditFlag: false,
        modelDetailFlag: false,
        copy: false,
               exportObj:{
          exportUrl:"/ntocc-basic-api/bulletin/exportNews",//导出接口
          name:'公告管理'
          },
        listQuery: {
          code: "",
          userCode: "",
          branchCode: "",
          imgUrl: "",
          title: "",
          content: "",
          editName: "",
          newsType: "",
          ifRelease: "",
          readNumber: "",
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        }
      };
    },
    async created() {
      this.dicts = { isRelease: {}, newsType: {} };
      this.dicts = await getDictByType("newsType,isRelease");
      this.findList();
    },
    methods: {
      findList() {
        this.loading = true;
        return new Promise(resolve => {
          request({
            url: "/ntocc-basic-api/bulletin",
            method: "get",
            params: this.listQuery
          }).then(response => {
            this.tableData = response.data.records;
            this.listQuery.total = response.data.total;
            this.loading = false;
            resolve();
          });
        });
      },
      // 添加方法
      funcAdd() {
        this.timer = new Date().getTime()
        /*this.$refs.addRef.init(this.dicts);*/
        this.modelAddFlag = true;
      },
      // 修改方法
      funcEdit(code) {
        this.timer = new Date().getTime()
        this.editCode = code;
        /*this.$refs.editRef.getInfo(code, this.dicts);*/
        this.modelEditFlag = true;
      },
      // 详情方法
      funcDetail(code) {
        this.$refs.detailRef.getInfo(code, this.dicts);
        this.modelDetailFlag = true;
      },
      // 发布方法
      funcPublish(code) {
        this.$confirm("确认发布吗？")
          .then(_ => {
            request({
              url: `/ntocc-basic-api/bulletin/publish/${code}`,
              method: "put"
            }).then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            });
          })
          .catch(_ => {});
      },
      // 删除方法
      funcDelete(row) {
        this.$confirm("确认删除吗？")
          .then(_ => {
            request({
              url: `/ntocc-basic-api/bulletin`,
              method: "delete",
              params: { codes: row }
            }).then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.findList();
            });
          })
          .catch(_ => {});
      },
      // 增加组件的父方法
      fatherAdd() {
        this.modelAddFlag = false;
        this.findList();
      },
      // 编辑组件的父方法
      fatherEdit() {
        this.modelEditFlag = false;
        this.findList();
      },
      // 公共取消
      fatherCancel(modelFlag) {
        switch (modelFlag) {
          case "add":
            this.modelAddFlag = false;
            break;
          case "edit":
            this.modelEditFlag = false;
            break;
          case "detail":
            this.modelDetailFlag = false;
            break;
          default:
        }
      },
      // 设置底部合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return "合计";
            }
            if (["pageviews", "forecast"].includes(column.property)) {
              return this.$XEUtils.sum(data, column.property);
            }
            return null;
          })
        ];
      }
    }
  };
  </script>
  